// @ts-nocheck

import { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';

// Components
import Text from 'app/shared/core/Text';

// Styles
import * as S from './styles';

// Utils
import imageUtils from 'app/shared/utils/imageUtils';

const Slide = ({
  body,
  btnPrimaryHref,
  btnPrimaryLabel,
  btnSecondaryHref,
  btnSecondaryLabel,
  heading,
  imgFull,
  imgSrc,
}) => {
  const ref = useRef();
  const dispatch = useDispatch();
  const [isInView, setIsInView] = useState(false);

  useEffect(() => {
    require('intersection-observer');
  }, []);

  // use IntersectionObserver to disable tab navigation of buttons on slides out of view
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsInView(true);
        } else {
          setIsInView(false);
        }
      },
      {
        threshold: 1, // only consider in view if every pixel is in view
      },
    );
    if (ref.current) {
      observer.observe(ref.current);
    }
  }, [ref]);

  return (
    <S.Container ref={ref}>
      <S.Image src={imageUtils.normalizeImageUrl(imgSrc)} imgFull={imgFull} />
      <S.TextContainer>
        <S.HeaderText htmlTag="h3" size="xl">
          {heading}
        </S.HeaderText>
        <Text size="md">{body}</Text>
      </S.TextContainer>
      <S.ButtonContainer>
        <S.PrimaryButton tabIndex={isInView ? 0 : -1} htmlTag="a" href={btnPrimaryHref}>
          {btnPrimaryLabel}
        </S.PrimaryButton>
        {btnSecondaryLabel && (
          <S.SecondaryButton tabIndex={isInView ? 0 : -1} to={btnSecondaryHref}>
            {btnSecondaryLabel}
          </S.SecondaryButton>
        )}
      </S.ButtonContainer>
    </S.Container>
  );
};

export default Slide;
